import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { AuthProvider } from 'react-oidc-context'
import { API_ORIGIN } from './lib/apiOrigin.ts'
import { completeSignIn, initUserManager } from './lib/auth.ts'
import { isKeycloakMode, loadAuthMode } from './lib/authMode.ts'
import { handleCallbackBeforeRouter } from './lib/callback.ts'
import { SignInProblem } from './pages/SignInProblem.tsx'

const root = createRoot(document.getElementById('root')!)

async function boot() {
  // The mode must be known before the first render: the API client, the log
  // stream and the route guard read it synchronously.
  try {
    await loadAuthMode(window.fetch.bind(window), API_ORIGIN)
  } catch {
    root.render(<SignInProblem kind="unreachable" />)
    return
  }
  const manager = initUserManager()
  if (!manager) {
    root.render(<SignInProblem kind="not_configured" />)
    return
  }
  // Keycloak returns to <origin>/auth/callback, outside the HashRouter.
  const callback = await handleCallbackBeforeRouter({
    keycloak: isKeycloakMode(),
    pathname: window.location.pathname,
    complete: completeSignIn,
    replace: (url) => window.history.replaceState(null, '', url),
  })
  if (callback === 'failed') {
    root.render(<SignInProblem kind="failed" />)
    return
  }
  root.render(
    <StrictMode>
      <AuthProvider
        userManager={manager}
        // Keycloak callbacks were handled above; legacy (Cognito, redirect to
        // the origin) still uses the provider's own handling, as today.
        skipSigninCallback={isKeycloakMode()}
        onSigninCallback={() => {
          window.history.replaceState({}, document.title, window.location.pathname)
        }}
      >
        <App />
      </AuthProvider>
    </StrictMode>,
  )
}

void boot()
